import { render, staticRenderFns } from "./accessibility.vue?vue&type=template&id=47cbb9d0&"
import script from "./accessibility.vue?vue&type=script&lang=js&"
export * from "./accessibility.vue?vue&type=script&lang=js&"
import style0 from "./accessibility.vue?vue&type=style&index=0&id=47cbb9d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports